import gql from "graphql-tag"

const SEARCH_SHOPPER_INSIGHTS = gql`
  query searchShopperInsights(
    $from: Int
    $size: Int
    $query: AWSJSON
    $aggs: AWSJSON
  ) {
    searchShopperInsights(
      from: $from
      size: $size
      query: $query
      aggs: $aggs
    ) {
      total
      aggregations
      hits {
        ... on ShopperInsightsSearchHitCheckout {
          id
          sessionId
          orderId
          orderReference
          storeGroupId
          countryCode
          currencyCode
          languageCode
          channelType
          created
          updated
          isConfirmed
          isPendingConfirmation
          paymentStatus {
            current
            log {
              state
              timestamp
              message
            }
          }
          shippingAddress {
            givenName
            familyName
            email
            telephoneNumber
            streetAddress
            streetAddress2
            postalCode
            city
            stateOrProvince
            country
          }
          items {
            id
            productParentId
            productVariantId
            name
            displayName
            quantity
            basePriceAmount
            salePriceAmount
            discountAmount
            totalPriceAmount
            totalDiscountAmount
            totalTaxAmount
          }
          providers {
            payment {
              providerName
              providerId
            }
            shipping {
              providerName
              providerId
            }
          }
        }
        ... on ShopperInsightsSearchHitSession {
          id
          storeGroupId
          countryCode
          currencyCode
          languageCode
          channelType
          created
          updated
          isTaxIncludedInPrice
          items {
            id
            productParentId
            productVariantId
            name
            displayName
            quantity
            basePriceAmount
            salePriceAmount
            discountAmount
            campaign {
              campaignId
              campaignGroupId
              name
            }
            tags {
              key
              value
            }
          }
          lock {
            checkoutId
            closed
          }
          providers {
            bonus {
              providerName
              providerId
            }
            giftCardProduct {
              providerName
              providerId
            }
            promotion {
              providerName
              providerId
            }
            voucher {
              providerName
              providerId
            }
          }
        }
        ... on ShopperInsightsSearchHitOrder {
          id
          reference
          sessionId
          checkoutId
          storeGroupId
          countryCode
          currencyCode
          languageCode
          channelType
          created
          updated
          checkoutProviders {
            payment {
              providerName
              providerId
            }
            shipping {
              providerName
              providerId
            }
          }
        }
      }
    }
  }
`

export default SEARCH_SHOPPER_INSIGHTS
